import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  loanAmmount: "50000",
  intrestRate: "1.8",
  monthlyPay: "5000",
  edErrors: null,
  monthsToPayoff: 0,
  creditErrors: null,
  totalAmount: 0,

}

const creditSlice = createSlice({
  name: 'creditCalculator',
  initialState,
  reducers: {

    setLoanAmmount: (state, action) => {
      state.loanAmmount = action.payload;
    },

    setIntrestRate: (state, action) => {
      state.intrestRate = action.payload;
    },
    setMonthlyPay: (state, action) => {
      state.monthlyPay = action.payload;
    },
    setTotalAmount: (state, action) => {
      state.totalAmount = action.payload;
    },
    // setCreditErrors: (state, action) => {
    //   state.edErrors = action.payload;
    // },
    setMonthsToPayoff: (state, action) => {
      state.monthsToPayoff = action.payload;
    },
    setCreditErrors: (state, action) => {
      state.creditErrors = action.payload;
    },
    resetCreditData: (state) => {
      return initialState;
    },
  }
});

export const { setActiveCalculater } = creditSlice.actions;
export const {
  setLoanAmmount, setMonthlyPay, setIntrestRate, setEdErrors, resetCreditData, setMonthsToPayoff, setTotalAmount
  , setCreditErrors } = creditSlice.actions;
export default creditSlice.reducer;
